import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getLoadPreview = (options: DefaultProductOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const { modal, user } = getModalTag(options.productType, 'Preview', [], options.projectID);

  return {
    modal,
    product,
    user,
  };
};
